import make, { Enum } from '@xaamin/enum';

class ComprobanteCancelacionStatus extends Enum {

  name = 'ComprobanteCancelacionStatus';

  enum = {
    'received': 0,
    'processing': 10,
    'cancelled': 1,
    'rejected': -1,
    'disallowed': 2,
    'error': 3,
    'dead': 4,
    'undefined': 999,
  }

}

export default make(ComprobanteCancelacionStatus);